import { __extends } from "tslib";
import * as React from 'react';
import { ProductLineItemDataHook } from '../../ProductLineItem';
import s from './OutOfStockWithAButton.scss';
import { SectionNotification, ButtonSize, ButtonPriority } from 'wix-ui-tpa';
import Error from 'wix-ui-icons-common/on-stage/Error';
var OutOfStockWithAButton = /** @class */ (function (_super) {
    __extends(OutOfStockWithAButton, _super);
    function OutOfStockWithAButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OutOfStockWithAButton.prototype.render = function () {
        var _a = this.props, message = _a.message, removeButtonText = _a.removeButtonText, removeButtonOnClick = _a.removeButtonOnClick;
        return (React.createElement(SectionNotification, { type: "error", className: s.root, "data-hook": ProductLineItemDataHook.OutOfStockWithAButton },
            React.createElement(SectionNotification.Icon, { icon: React.createElement(Error, null) }),
            React.createElement(SectionNotification.Text, null, message),
            React.createElement(SectionNotification.Button, { type: "default", key: "primary", size: ButtonSize.tiny, priority: ButtonPriority.basic, onClick: removeButtonOnClick }, removeButtonText)));
    };
    OutOfStockWithAButton.displayName = 'ProductLineItem.OutOfStock';
    return OutOfStockWithAButton;
}(React.PureComponent));
export { OutOfStockWithAButton };
//# sourceMappingURL=OutOfStockWithAButton.js.map